module.exports = __webpack_public_path__ + "img-front/register/locked.c3ae3424.svg";